import { render } from "./EditorTitle.vue?vue&type=template&id=3ff8db39&scoped=true"
import script from "./EditorTitle.vue?vue&type=script&lang=js"
export * from "./EditorTitle.vue?vue&type=script&lang=js"

import "./EditorTitle.vue?vue&type=style&index=0&id=3ff8db39&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ff8db39"]])

export default __exports__